module.exports = __webpack_public_path__ + "static/media/partner3.affc4063.png";